import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';

import { URL as DASHBOARD_URL } from 'pages/dashboard/helper';

import { DASHBOARD_RESOURCES } from 'constant';
import LotteryHome from './LotteryHome';
import { URL, COMPONENT, LOTTERY_RESOURCES, GET_ACTION } from './lotteryHelper';

const LotteryDashboardHome: React.FC = () => {
	// GET_ACTION
	return (
		<>
			<Switch>
				<AuthorizedRoute
					exact
					configPageName='dashboard'
					configResourceName='lottery'
					configActionName='GetAllLotteryCards'
					path={DASHBOARD_URL[DASHBOARD_RESOURCES.lottery]}
					component={LotteryHome}
				/>
				{_map(_values(LOTTERY_RESOURCES), (subEntity) => (
					<AuthorizedRoute
						key={subEntity}
						configPageName={DASHBOARD_RESOURCES.lottery}
						configResourceName={subEntity}
						configActionName={GET_ACTION[subEntity]}
						path={URL[subEntity]}
						component={COMPONENT[subEntity]}
					/>
				))}
				<Redirect to={DASHBOARD_URL[DASHBOARD_RESOURCES.lottery]} />
			</Switch>
		</>
	);
};

export default LotteryDashboardHome;
